import moment from 'moment'

const formatList = (list) =>
  list.map((item) => ({ ...item, DataConsulta: moment(item.DataConsulta).format('DD/MM/YYYY HH:mm') }))

export const StudentsHelper = {
  formatList,
}
